/** Shown wherever demo mode blocks an action that would otherwise change the
 *  real workspace — thunk-guard toasts and disabled-button tooltips alike,
 *  so the wording stays identical everywhere it appears. */
export const DEMO_MODE_BLOCKED_MESSAGE = 'Not available in demo mode.';
